import { Button } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

import Hero from '@/components/Hero/Hero'
import { RenderOn } from '@/utills/DeviceUtils'

const GenericHero: FC<{
    chips?: {
        items: {
            src: string
            width: number
            height: number
            sx?: SxProps
        }[]
        gap: number
    }
    title: ReactNode
    description: ReactNode
    button?: {
        label: string
        href: string
        target?: string
        rel?: string
    }
    backgroundImageMobile?: string
    backgroundImageDesktop?: string
    smallLabel?: string
}> = ({
    backgroundImageMobile,
    title,
    description,
    button,
    chips,
    backgroundImageDesktop,
    smallLabel,
}) => {
    return (
        <Hero
            chips={chips}
            backgroundImageDesktop={backgroundImageDesktop}
            backgroundImageMobile={backgroundImageMobile}
        >
            <Box
                sx={{
                    pb: 3,
                    pt: 9,
                    width: {
                        xs: '100%',
                        md: '65%',
                        lg: '50%',
                    },
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: {
                        xs: 'space-between',
                        md: 'center',
                    },
                    flexDirection: 'column',
                    gap: {
                        xs: 4,
                        md: 5,
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        flexDirection: 'column',
                        gap: {
                            xs: 4,
                            md: 5,
                        },
                    }}
                >
                    {smallLabel && (
                        <RenderOn breakPoints={['xs', 'sm']}>
                            <Box sx={{ pt: 3 }}>
                                <Text variant={'button'}>{smallLabel}</Text>
                            </Box>
                        </RenderOn>
                    )}
                    <RenderOn breakPoints={['xs', 'sm']}>
                        <Text variant={'h4'}>{title}</Text>
                    </RenderOn>
                    <RenderOn breakPoints={['xs', 'sm']}>
                        <Text variant={'body2'}>{description}</Text>
                    </RenderOn>
                    <RenderOn breakPoints={['md', 'lg', 'xl']}>
                        <Text variant={'h3'}>{title}</Text>
                    </RenderOn>
                    <RenderOn breakPoints={['md', 'lg', 'xl']}>
                        <Text variant={'body1'}>{description}</Text>
                    </RenderOn>
                </Box>
                {button && (
                    <Button
                        target={button.target || ''}
                        /* @ts-ignore: ... */
                        rel={button.rel || ''}
                        sx={{
                            width: {
                                xs: '100%',
                                md: 'unset',
                            },
                        }}
                        variant={'contained'}
                        leftIcon={<ArrowCircleRightIcon />}
                        href={button.href}
                    >
                        {button.label}
                    </Button>
                )}
            </Box>
        </Hero>
    )
}

export default GenericHero
